import { FileDownloadNotFoundPage } from "./file-download-not-found.page";

export const fileRoutes = [
  {
    path: "download",
    element: <FileDownloadNotFoundPage />, // inits currentFocusAreaListContext
  },
];
